<template>
  <div
    id="color-picker"
    class="colorPicker"
  >
    <strong
      v-if="colorPickerData.title"
      class="colorPickerTitle"
    >
      {{ colorPickerData.title.toUpperCase() }}
    </strong>
    <div class="colorOptions">
      <v-btn
        v-for="(color, index) in colorPickerData.availableColors"
        :key="index"
        class="colorOptions__colorOption"
        variant="flat"
        :class="color === getDisplayColor() ? 'selectedOption' : ''"
        :data-testid="color"
        :color="color"
        @click="handleColorClick(color)"
      />
      <v-btn
        v-if="colorPickerData.allowTransparent"
        class="colorOptions__colorOption"
        icon="mdi-water-off"
        variant="text"
        style="font-size: 12px; width: 22px; height: 22px;"
        data-testid="rgba(0,0,0,0)"
        :class="'rgba(0,0,0,0)' === getDisplayColor() ? 'selectedOption' : ''"
        @click="handleColorClick('rgba(0,0,0,0)')"
      />
    </div>
  </div>
</template>

<script>
import {ColorPickerOptions} from '@/services/GraphicService';

export default {
  name: 'ColorPicker',
  props: {
    colorPickerData: {
      type: ColorPickerOptions,
      default: null,
    },
  },
  emits: ['colorChange'],
  data() {
    return {
      /** @type {string} */
      clickedColor: null,
    };
  },
  watch: {
    colorPickerData: {
      handler() {
        // Whenever the colorPickerData prop updates, reset the locally selected color
        this.clickedColor = null;
      },
      deep: true,
    },
  },
  methods: {
    /**
     * handles the action when a user clicks a color on the color picker.
     * The colorPickerData object has a setColor function that accepts a color string.
     * This function calls the callback with the color chosen on this component
     * @param {string} color - the color passed to the callback
     */
    handleColorClick(color) {
      this.clickedColor = color;
      this.colorPickerData.setColor(color);
      this.$emit('colorChange', color);
    },
    /**
     * getDisplayColor - gets the currently selected color. If there is no selected color
     * in this component, we need to get the color from the colorPickerData itself.
     * @return {string} color
     */
    getDisplayColor() {
      return this.clickedColor ?? this.colorPickerData.getColor();
    },
  },
};
</script>

<style lang="scss" scoped>
.colorPicker {
  text-align: left;
}

.colorPickerTitle {
  font-size: 12px;
  font-family: main.$fontPrimary;
  color: main.$npGray;
  margin: 4px;
}

.colorOptions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 240px;
  row-gap: 6px;
  margin: 4px;
  margin-right: -4px;

  &__colorOption {
    border-radius: 50%;
    margin-left: -2px;
    margin-right: 6px;
    height: 20px;
    width: 20px;
    border: 1px solid #CCCCCCAA;
    min-width: unset;
    padding: unset;
    &:hover {
      border: 2px solid #CCCCCC;
    }
  }
}

.selectedOption {
  border: 2px solid black;
}

</style>
